import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  style: {"color":"cornflowerblue"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "退出", -1)

import { reactive, onMounted,onUnmounted,watch, computed } from 'vue';
import { ElTable, ElMessage,ElBacktop } from 'element-plus';
import $http from '../http/index';
import $helper from '../helper/helper';
import detailProductInfo from '../components/DetailProductInfo.vue';

// 车型匹配
interface CarModelsInfoMatch{
    // 省
    province:string,
    // 省
    city:string,
    // 车型详细信息
    carInfo:string,
    // 品牌 
    Brands:string,
    // 车型 
    CarModel:string,
    // 排量 
    OutputVolume:string,
    // 车辆类别 
    VehicleType:string,
    // 驱动方式
    DrivingModel:string,
    // 上市时间
    SaleTime:string,
    // 上市年份
    SaleYear:string,
    // 上市月份
    SaleMonth:string,
    // 停产时间
    StopTime:string,
    // 停产年份
    StopYear:string,
    // 停产月份
    StopMonth:string,
    // 前刹车 
    BrakeFront:string,
    // 后刹车 
    BrakeAfter:string,
    // 手刹片 
    HandBrake:string,
    // 前刹车盘 
    BrakeDiscFront:string,
    // 后刹车盘 
    BrakeDiscAfter:string,
    // 前报警线
    AlarmLineFront:string,
    // 后报警线
    AlarmLineAfter:string,
    // 车型匹配编号区别 
    Note:string,
    // 保有量 
    Retention:string,
    // 市场来源
    MarketSource:string,
    // 车厂
    Factory:string,
    // 第三方保有量 
    OtherRetention:number
}

// 入参

export default /*#__PURE__*/_defineComponent({
  __name: 'BaoYouLiangList',
  props: {
    loading: { type: Boolean },
    searchParamJson: null,
    tableDataJson: null,
    totalMsg: null,
    productTypesChecked: null
  },
  setup(__props: any) {

const props = __props as {
    loading:boolean  //是否正在查询数据
    searchParamJson:string //查询参数
    tableDataJson:string //列表数据Json
    totalMsg:string //汇总数据
    productTypesChecked:string[]
};



class InitData{
    navigateHeaderHeight={
        height:"125px"
    }
    contentMain = {
        'min-height': '100px',
        'height': '100px',
        'padding': '5px',
        'padding-top': '5px',
        'scroll':'no',
    }
    tableListStyle={
        width: '100%',
        height: '300px'
    }
    totalMsgStyle={
        'color': '#DDD',
        'background-color': '#555555',
        'margin': '3px 0px',
        'padding': '5px 5px'
    }
    windowWidthAndHeight='' //窗口的宽高
    tableData:Array<CarModelsInfoMatch>=[]
    totalMsg=`暂无数据`
    productTypesChecked:string[]=[]
    loading=false  //是否正在查询数据

    //产品详情页面参数
    showDetailProductInfo=false //是否展示产品详情页
    showName='' //产品显示名字
    gloryModel=''
    typeCodeClassfy=''
    procudtCodes:Array<string>=[]
}

const data = reactive(new InitData());

let intervalResult = -1;

onMounted(()=>{
    adapterSize();
    data.productTypesChecked = JSON.parse(JSON.stringify(props.productTypesChecked));
    intervalResult = window.setInterval(()=>{
        data.windowWidthAndHeight = window.innerWidth+"-"+window.innerHeight;
    },500)
})

onUnmounted(()=>{
    if(intervalResult!=-1){
        window.clearInterval(intervalResult);
    }
})

const blankHeaderStyle = computed(()=>{
    let height = Number.parseInt(data.navigateHeaderHeight.height.replaceAll("px",""));
    return {
        height:`${height+153}px`,
        padding:'0px 0px'
    }
})

watch(()=>data.windowWidthAndHeight,()=>{
    adapterSize();
})

watch(()=>props.tableDataJson,()=>{
    getAllProcudtCode();
    data.tableData = JSON.parse(props.tableDataJson);
    for(let i=0;data.tableData &&i<data.tableData.length;i++){
        data.tableData[i]["carInfo"] = combineCarInfo(data.tableData[i])
    }
})

watch(()=>JSON.stringify(props.productTypesChecked),()=>{
    data.productTypesChecked = JSON.parse(JSON.stringify(props.productTypesChecked));
})

watch(()=>props.totalMsg,()=>{
    if(!props.totalMsg){
        data.totalMsg = "暂无数据"
    }else{
        data.totalMsg = props.totalMsg;
    }
    
})

watch(()=>props.loading,()=>{
    console.log("props.loading change "+props.loading)
    data.loading = props.loading;
})

const combineCarInfo = (match:CarModelsInfoMatch):string=>{
    let result = '';
    if(!match){
        return result;
    }
    result = `${match.Factory} ${match.CarModel} ${match.OutputVolume} ${match.VehicleType} ${match.DrivingModel}`;
    if(match.SaleTime){
        result = `${result} ${match.SaleTime}`;
    }
    if(match.SaleTime && match.StopTime){
        result = `${result} ~`;
    }
    if( match.StopTime){
        result = `${result} ${match.StopTime}`;
    }
    return result;
}

const adapterSize = ()=>{
    let navigateHeaderHeight = document.getElementsByClassName('navigateHeader')[0]?.clientHeight;
    let contentFootHeight =  document.getElementById('contentFoot')?.clientHeight;
    if(contentFootHeight == undefined){
        contentFootHeight = 0;
    }
    data.navigateHeaderHeight.height = `${navigateHeaderHeight}px`;
    let blankHeaderHeight = document.getElementById("blankHeader")?.clientHeight;
    if(blankHeaderHeight == undefined){
        blankHeaderHeight = 0;
    }
    //console.log(`window.innerHeight = ${window.innerHeight}  blankHeaderHeight=${blankHeaderHeight}  contentFootHeight=${contentFootHeight}`);
    let contentMainHeight = (window.innerHeight - blankHeaderHeight - contentFootHeight - 1) + "px"; //多减一个像素，防止出现非必要滚动条
    data.contentMain['min-height'] = contentMainHeight
    data.contentMain['height'] = contentMainHeight
    data.contentMain['padding-top'] = '0px'
    data.tableListStyle.height=Number.parseInt(data.contentMain.height.replaceAll('px',''))-45+'px';
};

const dataExport = () =>{
    if(!JSON.parse(props.searchParamJson)["Brand"]){
        ElMessage.error("必须选择品牌");
        return;
    }
    if(!JSON.parse(props.searchParamJson)["Province"]){
        ElMessage.error("必须选择省份");
        return;
    }
    ElMessage.info("数据导出中...");
    $http({
        url: "/API/Product/BaoYouLiangPrint",
        method: "POST",
        data: {
            searchCondition: props.searchParamJson,
            productTypesCheckeds:JSON.stringify(props.productTypesChecked)
        }
    }).then(res => {
        let link = document.createElement("a");
        link.style.display="none";
        link.href = `${process.env.VUE_APP_BASE_API}/API/Product/FileDownload?cacheKey=${res.data}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

/**
 * 保有量数据格式化
 * @param retention 
 */
const OtherRetentionFormat=(retention:number)=>{
    let r = $helper.commafy(retention);
    if(r=="0"){
        return "";
    }
    return r;
}

const productCodeClick=(code:string,showName:string,productType:string)=>{
    data.gloryModel = code;
    data.showName = showName;
    data.showDetailProductInfo=true;
    data.typeCodeClassfy=productType;
}

const getAllProcudtCode =()=>{
    if(data.procudtCodes.length>0){
        return;
    }
    $http({
        url: "/API/Product/AllProcudtCode",
        method: "POST",
        data: {
        }
    }).then(res => {
        data.procudtCodes = res.data;
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_DArrowLeft = _resolveComponent("DArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          id: "blankHeader",
          style: _normalizeStyle(_unref(blankHeaderStyle))
        }, null, 8, ["style"]),
        _createVNode(_component_el_main, {
          id: "contentMain",
          style: _normalizeStyle(data.contentMain)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: _normalizeStyle(data.totalMsgStyle)
            }, [
              _createElementVNode("div", {
                innerHTML: _unref($helper).lan(data.totalMsg),
                style: {"width":"80%","float":"left"}
              }, null, 8, _hoisted_1),
              _withDirectives(_createElementVNode("div", {
                style: {"float":"right","cursor":"pointer"},
                onClick: dataExport
              }, "导出数据", 512), [
                [_vShow, data.tableData.length>0&&_unref($helper).hasPermission('dataExport')]
              ]),
              _hoisted_2
            ], 4),
            _withDirectives((_openBlock(), _createBlock(_unref(ElTable), {
              data: data.tableData,
              style: _normalizeStyle(data.tableListStyle),
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "Province",
                  label: "省",
                  "min-width": "5%"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "City",
                  label: "市",
                  "min-width": "5%"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "carInfo",
                  label: "详细车型信息",
                  "min-width": "33%"
                }),
                (data.productTypesChecked.indexOf('BrakePads')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      prop: "BrakeFront",
                      label: "前刹车",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.BrakeFrontBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.BrakeFront,scope.row.BrakeFrontBrand,'BrakePads')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.BrakeFrontBrand), 9, _hoisted_3))
                          : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.BrakeFrontBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (data.productTypesChecked.indexOf('BrakePads')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      prop: "BrakeAfter",
                      label: "后刹车",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.BrakeAfterBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.BrakeAfter,scope.row.BrakeAfterBrand,'BrakePads')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.BrakeAfterBrand), 9, _hoisted_5))
                          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(scope.row.BrakeAfterBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (data.productTypesChecked.indexOf('HandBrake')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      prop: "HandBrake",
                      label: "手刹片",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.HandBrakeBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.HandBrake,scope.row.HandBrakeBrand,'HandBrake')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.HandBrakeBrand), 9, _hoisted_7))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.HandBrakeBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (data.productTypesChecked.indexOf('BrakeDisc')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 3,
                      prop: "BrakeDiscFront",
                      label: "前刹车盘",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.BrakeDiscFrontBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.BrakeDiscFront,scope.row.BrakeDiscFrontBrand,'BrakeDisc')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.BrakeDiscFrontBrand), 9, _hoisted_9))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row.BrakeDiscFrontBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (data.productTypesChecked.indexOf('BrakeDisc')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 4,
                      prop: "BrakeDiscAfter",
                      label: "后刹车盘",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.BrakeDiscAfterBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.BrakeDiscAfter,scope.row.BrakeDiscAfterBrand,'BrakeDisc')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.BrakeDiscAfterBrand), 9, _hoisted_11))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(scope.row.BrakeDiscAfterBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (data.productTypesChecked.indexOf('WarnLine')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 5,
                      prop: "AlarmLineFront",
                      label: "前报警线",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.AlarmLineFrontBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.AlarmLineFront,scope.row.AlarmLineFrontBrand,'WarnLine')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.AlarmLineFrontBrand), 9, _hoisted_13))
                          : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.AlarmLineFrontBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (data.productTypesChecked.indexOf('WarnLine')>-1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 6,
                      prop: "AlarmLineAfter",
                      label: "后报警线",
                      "min-width": "6%"
                    }, {
                      default: _withCtx((scope) => [
                        (data.procudtCodes.includes(scope.row.AlarmLineAfterBrand))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: ($event: any) => (productCodeClick(scope.row.AlarmLineAfter,scope.row.AlarmLineAfterBrand,'WarnLine')),
                              class: "baoYouLiangListProductCode"
                            }, _toDisplayString(scope.row.AlarmLineAfterBrand), 9, _hoisted_15))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(scope.row.AlarmLineAfterBrand), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "Note",
                  label: "车型匹配区别",
                  "min-width": "9%"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "OtherRetention",
                  label: "保有量",
                  "min-width": "6%"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(OtherRetentionFormat(scope.row.OtherRetention)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "style"])), [
              [_directive_loading, data.loading]
            ]),
            _createVNode(_unref(ElBacktop), { target: ".el-scrollbar__wrap" })
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_el_footer, {
          id: "contentFoot",
          style: {"height":"0px","display":"none"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Copyright@2022-2022   珠海格莱利摩擦材料股份有限公司版权所有   All Rights Reserved ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "compareProductInfoDialog",
      modelValue: data.showDetailProductInfo,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.showDetailProductInfo) = $event)),
      "show-close": false,
      width: "1000px",
      "align-center": true
    }, {
      header: _withCtx(({ close }) => [
        _createVNode(_component_el_row, { style: {"margin-bottom":"3px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 21 }, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(data.showName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DArrowLeft)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 返回搜索界面 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 22 }),
            _createVNode(_component_el_col, { span: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  underline: false,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (data.showDetailProductInfo=false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_17,
                    _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Close)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(detailProductInfo, {
          "glory-model": data.gloryModel,
          "type-code": data.typeCodeClassfy
        }, null, 8, ["glory-model", "type-code"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})